import {
  NEXT_STAGE,
  PREVIOUS_STAGE,
  SUBMIT_FINAL,
  NEXT_BUTTON_UPDATE,
  SAVE_AND_EXIT_UPDATE,
  DETAILS_AVAILABLE_TO_PROCEED,
} from "../config/constants";

export const incrementStage = () => ({
  type: NEXT_STAGE,
});
export const decrementStage = () => ({
  type: PREVIOUS_STAGE,
});
export const submitFinal = () => ({
  type: SUBMIT_FINAL,
});
export const saveAndExitUpdate = (bool) => ({
  type: SAVE_AND_EXIT_UPDATE,
  payload: bool,
});
export const nextButtonUpdate = (bool) => ({
  type: NEXT_BUTTON_UPDATE,
  payload: bool,
});
export const detailsAvailableToProceed = (bool) => ({
  type: DETAILS_AVAILABLE_TO_PROCEED,
  payload: bool,
});
